module.exports = __webpack_public_path__ + "img/pic31.c925d88a.png";